import { Node, mergeAttributes, CommandProps } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    documentAttachment: {
      setDocumentAttachment: (options: {
        'data-file-id': string;
        'data-file-name': string;
      }) => ReturnType;
    };
  }
}

export const DocumentAttachment = Node.create({
  name: 'documentAttachment',
  group: 'block',
  atom: true,
  draggable: true, 
  selectable: true,

  addAttributes() {
    return {
      'data-file-id': {
        default: null,
        parseHTML: el => el.getAttribute('data-file-id'),
        renderHTML: attrs => ({ 'data-file-id': attrs['data-file-id'] }),
      },
      'data-file-name': {
        default: null,
        parseHTML: el => el.getAttribute('data-file-name'),
        renderHTML: attrs => ({ 'data-file-name': attrs['data-file-name'] }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div.document-attachment' }];
  },

  renderHTML({ HTMLAttributes }) {

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'document-attachment',
        contenteditable: 'false',
        unselectable: 'on',
      }),
      [
        'span',
        { contenteditable: 'false' },
        HTMLAttributes['data-file-name'] || 'Unnamed file',
      ],
    ];
  },

  addCommands() {
    return {
      setDocumentAttachment:
        (options: { 'data-file-id': string; 'data-file-name': string }) =>
        ({ chain }: CommandProps) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: options,
            })
            .run();
        },
    };
  },
});